import PropTypes from "prop-types";

export const MenuLayout = ({ children, hasError = false, messageError }) => {
  if (hasError) {
    return (
      <>
        <div className="overflow-hidden">
          <div className="flex items-center justify-center m-auto h-screen w-full  animate__animated animate__zoomIn">
            <h1 className="text-2xl text-black font-bold">{messageError}</h1>
          </div>
        </div>
      </>
    );
  }
  return <div className=" animate__animated animate__fadeIn">{children}</div>;
};

MenuLayout.propTypes = {
  children: PropTypes.node,
  hasError: PropTypes.bool,
  messageError: PropTypes.string,
};
